// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__37Q2H","icon":"styles_icon__2Q42a"};